import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { usePassioApi } from "../hooks/usePassioApi";

export const TokenUsageInitializer: React.FC = () => {
    const { dbUser } = useAuth();
    const hasInitialized = useRef(false);
    const lastApiKey = useRef<string | null>(null);
    const apiKey = dbUser?.passioapikey || process.env.REACT_APP_PASSIO_API_KEY || "";
    const [hasValidApiKey, setHasValidApiKey] = useState(false);

    // Track if API key changes
    useEffect(() => {
        const isValid = !!(apiKey && apiKey.length > 0);
        setHasValidApiKey(isValid);
        
        // If API key changed, reset initialization
        if (apiKey !== lastApiKey.current) {
            hasInitialized.current = false;
            lastApiKey.current = apiKey;
        }
    }, [apiKey]);

    const { client, isInitializing } = usePassioApi();

    useEffect(() => {
        const initializeTokenUsage = async () => {
            if (client && hasValidApiKey && !hasInitialized.current && !isInitializing) {
                try {
                    hasInitialized.current = true;
                    // Call the initializeTokenUsage method on the client
                    await client.initializeTokenUsage();
                    console.log("Token usage initialized");
                } catch (error) {
                    console.error("Failed to initialize token usage:", error);
                    // Don't reset hasInitialized on error to avoid infinite retries
                }
            }
        };

        initializeTokenUsage();
    }, [client, hasValidApiKey, isInitializing]);

    return null; // This component doesn't render anything
};
